import React, { useState, useEffect } from 'react';
import './AdminPage.css';

// Cấu hình Google Script URL từ environment variable (trim để tránh khoảng trắng)
const GOOGLE_SCRIPT_URL = (process.env.REACT_APP_GOOGLE_SCRIPT_URL || '').trim();

function AdminPage() {
  const [activeTab, setActiveTab] = useState('employees');
  const [employees, setEmployees] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [googleMapLink, setGoogleMapLink] = useState('');

  // Employee form
  const [employeeForm, setEmployeeForm] = useState({
    code: '',
    name: '',
    position: '',
    department: '',
    email: '',
    phone: '',
    project: '',
    status: 'Đang làm việc',
    password: '123456'
  });

  // Project form
  const [projectForm, setProjectForm] = useState({
    code: '',
    name: '',
    address: '',
    latitude: '',
    longitude: '',
    radius: '',
    status: 'hoạt động'
  });

  // Export form
  const [exportForm, setExportForm] = useState({
    startDate: '',
    endDate: '',
    employeeId: '',
    columns: [
      'Mã số nhân viên',
      'Tên nhân viên',
      'Chức danh',
      'Phòng ban',
      'Ngày',
      'Thứ',
      'Giờ vào',
      'Giờ ra',
      'Tổng giờ ca HC',
      'Tổng giờ OT',
      'Dự án',
      'Địa điểm làm việc',
      'Giải Trình',
      'Ghi Chú'
    ]
  });

  // Clear Data form
  const [clearDataForm, setClearDataForm] = useState({
    startDate: '',
    endDate: ''
  });

  const availableColumns = [
    'Mã số nhân viên',
    'Tên nhân viên',
    'Chức danh',
    'Phòng ban',
    'Ngày',
    'Thứ',
    'Giờ vào',
    'Giờ ra',
    'Tổng giờ ca HC',
    'Tổng giờ OT',
    'Dự án',
    'Địa điểm làm việc',
    'Giải Trình',
    'Ghi Chú'
  ];

  useEffect(() => {
    loadEmployees();
    loadProjects();
  }, []);

  const loadEmployees = async () => {
    try {
      const response = await fetch(`${GOOGLE_SCRIPT_URL}?action=employees`);
      const result = await response.json();
      if (result.ok && result.data) {
        setEmployees(result.data);
      }
    } catch (error) {
      console.error('Error loading employees:', error);
      alert('Không thể tải danh sách nhân viên');
    }
  };

  const loadProjects = async () => {
    try {
      const response = await fetch(`${GOOGLE_SCRIPT_URL}?action=projects`);
      const result = await response.json();
      if (result.ok && result.data) {
        setProjects(result.data);
      }
    } catch (error) {
      console.error('Error loading projects:', error);
      alert('Không thể tải danh sách dự án');
    }
  };

  const handleAddEmployee = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Sử dụng URLSearchParams để tránh preflight CORS
      // Google Apps Script Web App xử lý form-urlencoded tốt hơn JSON
      const params = new URLSearchParams();
      params.append('action', 'addEmployee');
      params.append('code', employeeForm.code);
      params.append('name', employeeForm.name);
      params.append('position', employeeForm.position || '');
      params.append('department', employeeForm.department || '');
      params.append('email', employeeForm.email || '');
      params.append('phone', employeeForm.phone || '');
      params.append('project', employeeForm.project || '');
      params.append('status', employeeForm.status || 'Đang làm việc');
      params.append('password', employeeForm.password || '123456');

      // Sử dụng form-urlencoded để tránh preflight request
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString()
      });

      // Kiểm tra response
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Response error:', response.status, errorText);
        throw new Error(`HTTP ${response.status}: ${errorText.substring(0, 100)}`);
      }

      const contentType = response.headers.get('content-type') || '';
      let result;
      
      if (contentType.includes('application/json')) {
        result = await response.json();
      } else {
        // Nếu không phải JSON, thử parse text
        const text = await response.text();
        console.log('Response text:', text);
        try {
          result = JSON.parse(text);
        } catch (e) {
          throw new Error('Server trả về dữ liệu không hợp lệ: ' + text.substring(0, 200));
        }
      }

      if (result.ok) {
        alert('Thêm nhân viên thành công!');
        setEmployeeForm({
          code: '',
          name: '',
          position: '',
          department: '',
          email: '',
          phone: '',
          project: '',
          status: 'Đang làm việc',
          password: '123456'
        });
        loadEmployees();
      } else {
        alert('Lỗi: ' + (result.error || 'Không thể thêm nhân viên'));
      }
    } catch (error) {
      console.error('Error details:', error);
      alert('Lỗi: ' + error.message + '\n\nVui lòng kiểm tra:\n1. Google Script URL có đúng không\n2. Google Script đã được deploy với quyền "Anyone" chưa\n3. Mở Console (F12) để xem chi tiết lỗi\n\nHướng dẫn deploy Google Script:\n1. Mở Google Apps Script Editor\n2. Click Deploy > New deployment\n3. Chọn type: Web app\n4. Execute as: Me\n5. Who has access: Anyone\n6. Click Deploy và copy URL mới');
    } finally {
      setLoading(false);
    }
  };

  const handleAddProject = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Sử dụng URLSearchParams để tránh preflight CORS
      const params = new URLSearchParams();
      params.append('action', 'addProject');
      params.append('code', projectForm.code);
      params.append('name', projectForm.name);
      params.append('address', projectForm.address || '');
      params.append('latitude', parseFloat(projectForm.latitude) || 0);
      params.append('longitude', parseFloat(projectForm.longitude) || 0);
      params.append('radius', parseFloat(projectForm.radius) || 0);
      params.append('status', projectForm.status || 'hoạt động');

      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString()
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Response error:', response.status, errorText);
        throw new Error(`HTTP ${response.status}: ${errorText.substring(0, 100)}`);
      }

      const contentType = response.headers.get('content-type') || '';
      let result;
      
      if (contentType.includes('application/json')) {
        result = await response.json();
      } else {
        const text = await response.text();
        console.log('Response text:', text);
        try {
          result = JSON.parse(text);
        } catch (e) {
          throw new Error('Server trả về dữ liệu không hợp lệ: ' + text.substring(0, 200));
        }
      }

      if (result.ok) {
        alert('Thêm dự án thành công!');
        setProjectForm({
          code: '',
          name: '',
          address: '',
          latitude: '',
          longitude: '',
          radius: '',
          status: 'hoạt động'
        });
        loadProjects();
      } else {
        alert('Lỗi: ' + (result.error || 'Không thể thêm dự án'));
      }
    } catch (error) {
      console.error('Error details:', error);
      alert('Lỗi: ' + error.message + '\n\nVui lòng kiểm tra:\n1. Google Script URL có đúng không\n2. Google Script đã được deploy với quyền "Anyone" chưa\n3. Mở Console (F12) để xem chi tiết lỗi');
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Sử dụng GET request với query parameters (dễ hơn với CORS)
      let url = `${GOOGLE_SCRIPT_URL}?action=exportReport`;

      // #region agent log - export start
      try {
        const logData = {
          location: 'AdminPage.js:handleExport',
          message: 'exportReport start',
          data: {
            startDate: exportForm.startDate,
            endDate: exportForm.endDate,
            employeeId: exportForm.employeeId,
            columns: exportForm.columns,
          },
          timestamp: Date.now(),
          sessionId: 'debug-session',
          runId: 'run-export',
          hypothesisId: 'R1', // Export params or filters incorrect / missing
        };
        console.log('[DEBUG]', logData);
        fetch('http://127.0.0.1:7244/ingest/ea6218cf-eb2d-4eb6-a10c-66d9cf5c51b1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(logData),
        }).catch(() => {});
      } catch (e) {
        // ignore logging errors
      }
      // #endregion
      if (exportForm.startDate) {
        url += `&startDate=${encodeURIComponent(exportForm.startDate)}`;
      }
      if (exportForm.endDate) {
        url += `&endDate=${encodeURIComponent(exportForm.endDate)}`;
      }
      if (exportForm.employeeId) {
        url += `&employeeId=${encodeURIComponent(exportForm.employeeId)}`;
      }
      // Gửi columns dưới dạng comma-separated
      url += `&columns=${encodeURIComponent(exportForm.columns.join(','))}`;
      
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Accept': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Export response:', result);
      console.log('Response keys:', Object.keys(result));
      console.log('result.ok:', result.ok);
      console.log('result.downloadUrl:', result.downloadUrl);
      console.log('result.error:', result.error);

      // #region agent log - export result
      try {
        const logDataResult = {
          location: 'AdminPage.js:handleExport',
          message: 'exportReport result',
          data: {
            httpStatus: response.status,
            ok: result?.ok,
            hasDownloadUrl: !!result?.downloadUrl,
            error: result?.error || null,
            debug: result?.debug ? 'present' : null,
          },
          timestamp: Date.now(),
          sessionId: 'debug-session',
          runId: 'run-export',
          hypothesisId: 'R2', // Backend / Apps Script response structure or permissions
        };
        console.log('[DEBUG]', logDataResult);
        fetch('http://127.0.0.1:7244/ingest/ea6218cf-eb2d-4eb6-a10c-66d9cf5c51b1', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(logDataResult),
        }).catch(() => {});
      } catch (e) {
        // ignore logging errors
      }
      // #endregion
      
      // Check if response is successful
      if (result.ok === true && result.downloadUrl) {
        // Download Excel từ Google Drive
        window.open(result.downloadUrl, '_blank');
        alert('File Excel đã được tạo! Vui lòng click vào link để tải về.\n\n' + (result.message || ''));
      } else {
        console.error('Export failed:', result);
        var errorMsg = result.error || 'Không thể xuất báo cáo';
        if (result.debug) {
          console.error('Debug info:', result.debug);
          errorMsg += '\n\nDebug: ' + JSON.stringify(result.debug);
        }
        // Also log the full response for debugging
        console.error('Full response:', JSON.stringify(result, null, 2));
        alert('Lỗi: ' + errorMsg);
      }
    } catch (error) {
      console.error('Export error:', error);
      alert('Lỗi: ' + error.message + '\n\nVui lòng kiểm tra:\n1. Google Script URL có đúng không\n2. Google Script đã được deploy với quyền "Anyone" chưa\n3. Kiểm tra Console (F12) để xem chi tiết lỗi');
    } finally {
      setLoading(false);
    }
  };

  const handleClearData = async (e) => {
    e.preventDefault();
    
    if (!clearDataForm.startDate || !clearDataForm.endDate) {
      alert('⚠️ Vui lòng nhập đầy đủ ngày bắt đầu và ngày kết thúc');
      return;
    }

    const confirmMessage = `⚠️ CẢNH BÁO: Bạn sắp xóa TẤT CẢ dữ liệu chấm công từ ${clearDataForm.startDate} đến ${clearDataForm.endDate}.\n\n` +
      `Hành động này sẽ:\n` +
      `- Xóa tất cả các dòng trong Google Sheet "ChamCong"\n` +
      `- Xóa tất cả ảnh trong Google Drive trong khoảng thời gian này\n\n` +
      `⚠️ HÀNH ĐỘNG NÀY KHÔNG THỂ HOÀN TÁC!\n\n` +
      `Bạn có chắc chắn muốn tiếp tục?`;
    
    if (!window.confirm(confirmMessage)) {
      return;
    }

    // Xác nhận lần 2
    const confirmMessage2 = `⚠️ XÁC NHẬN LẦN CUỐI:\n\n` +
      `Bạn sẽ xóa dữ liệu từ ${clearDataForm.startDate} đến ${clearDataForm.endDate}.\n\n` +
      `Nhập "XÓA" để xác nhận:`;
    
    const userInput = window.prompt(confirmMessage2);
    if (userInput !== 'XÓA') {
      alert('Đã hủy. Dữ liệu không bị xóa.');
      return;
    }

    setLoading(true);
    try {
      // Sử dụng form-urlencoded để tránh preflight request (CORS issue)
      const formData = new URLSearchParams();
      formData.append('action', 'clearData');
      formData.append('startDate', clearDataForm.startDate);
      formData.append('endDate', clearDataForm.endDate);
      
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      const result = await response.json();
      
      if (result.ok) {
        alert(`✅ Đã xóa thành công!\n\n` +
          `- Đã xóa ${result.deletedRows || 0} dòng trong Google Sheet\n` +
          `- Đã xóa ${result.deletedImages || 0} ảnh trong Google Drive`);
        // Reset form
        setClearDataForm({ startDate: '', endDate: '' });
      } else {
        alert('❌ Lỗi: ' + (result.error || 'Không thể xóa dữ liệu'));
      }
    } catch (error) {
      console.error('Clear data error:', error);
      alert('❌ Lỗi: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const toggleColumn = (column) => {
    setExportForm(prev => {
      const columns = [...prev.columns];
      const index = columns.indexOf(column);
      if (index > -1) {
        columns.splice(index, 1);
      } else {
        columns.push(column);
      }
      return { ...prev, columns };
    });
  };

  // Parse Google Maps link để lấy tọa độ
  const handleParseGoogleMapLink = async () => {
    if (!googleMapLink || !googleMapLink.trim()) {
      alert('Vui lòng nhập link Google Maps');
      return;
    }

    let link = googleMapLink.trim();
    
    // Kiểm tra nếu là short link (goo.gl hoặc maps.app.goo.gl)
    if (link.includes('goo.gl/') || link.includes('maps.app.goo.gl/')) {
      // Short link Google Maps không thể resolve trực tiếp do CORS
      // Hướng dẫn user mở link và copy full URL
      alert('📌 Link rút gọn Google Maps không thể tự động resolve do CORS.\n\n🔧 Cách xử lý:\n1. Click vào link để mở Google Maps trong tab mới\n2. Copy full URL từ thanh địa chỉ trình duyệt\n   (Dạng: https://www.google.com/maps/@lat,lng hoặc ?q=lat,lng)\n3. Dán full URL vào đây\n\n💡 Tip: Sau khi mở link, URL sẽ tự động chuyển thành full URL có chứa tọa độ.');
      
      // Mở link trong tab mới để user có thể copy full URL
      window.open(link, '_blank');
      
      return; // Dừng lại, chờ user dán full URL
    }
    
    // Nếu không phải short link, tiếp tục parse
    await parseLink(link);
  };
  
  // Hàm parse link sau khi đã resolve
  const parseLink = async (link) => {
    // Kiểm tra lại nếu vẫn là short link (user có thể đã dán lại)
    if (link.includes('goo.gl/') || link.includes('maps.app.goo.gl/')) {
      alert('⚠️ Vui lòng dán full URL (không phải short link).\n\nMở link trong trình duyệt và copy URL từ thanh địa chỉ.');
      return;
    }
    
    let lat = null;
    let lng = null;

    // Các format link Google Maps:
    // 1. https://www.google.com/maps?q=lat,lng
    // 2. https://www.google.com/maps/@lat,lng,zoom
    // 3. https://www.google.com/maps/place/.../@lat,lng,zoom
    // 4. https://maps.google.com/?q=lat,lng
    // 5. https://goo.gl/maps/... hoặc https://maps.app.goo.gl/... (short link - đã resolve)
    // 6. https://www.google.com/maps/place/.../data=... (với place data)

    // Format 1 & 4: ?q=lat,lng hoặc ?q=place+name
    const qMatch = link.match(/[?&]q=([^&]+)/);
    if (qMatch) {
      const qValue = qMatch[1];
      // Kiểm tra xem có phải là tọa độ không (lat,lng)
      const coordMatch = qValue.match(/^([+-]?[\d.]+),([+-]?[\d.]+)$/);
      if (coordMatch) {
        lat = parseFloat(coordMatch[1]);
        lng = parseFloat(coordMatch[2]);
      }
      // Nếu không phải tọa độ, sẽ xử lý sau bằng Places API
    }

    // Format 2 & 3: @lat,lng hoặc /place/.../@lat,lng
    if ((!lat || !lng || isNaN(lat) || isNaN(lng)) && link.includes('@')) {
      const atMatch = link.match(/@([+-]?[\d.]+),([+-]?[\d.]+)/);
      if (atMatch) {
        lat = parseFloat(atMatch[1]);
        lng = parseFloat(atMatch[2]);
      }
    }
    
    // Format: /data=... (trong một số link Google Maps)
    if ((!lat || !lng || isNaN(lat) || isNaN(lng)) && link.includes('/data=')) {
      const dataMatch = link.match(/\/data=([^&]+)/);
      if (dataMatch) {
        // Decode và parse data parameter
        try {
          const decoded = decodeURIComponent(dataMatch[1]);
          // Tìm tọa độ trong data string
          const coordInData = decoded.match(/([+-]?[\d.]+),([+-]?[\d.]+)/);
          if (coordInData) {
            lat = parseFloat(coordInData[1]);
            lng = parseFloat(coordInData[2]);
          }
        } catch (e) {
          console.error('Error parsing data parameter:', e);
        }
      }
    }

    // Nếu vẫn không parse được tọa độ, không thể làm gì thêm
    // (Không dùng Google Maps API để tránh cần API key)
    if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
      alert('❌ Không thể parse tọa độ từ link Google Maps.\n\nVui lòng:\n1. Mở link trong trình duyệt\n2. Copy full URL từ thanh địa chỉ (phải có dạng @lat,lng hoặc ?q=lat,lng)\n3. Dán lại vào đây\n\n💡 Link phải chứa tọa độ (số), không phải tên địa điểm.');
      return;
    }

    if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
      // Reverse geocoding để lấy địa chỉ - sử dụng OpenStreetMap Nominatim (miễn phí, không cần API key)
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1&accept-language=vi`,
          {
            headers: {
              'User-Agent': 'ChamCongApp/1.0' // Nominatim yêu cầu User-Agent
            }
          }
        );
        
        if (response.ok) {
          const data = await response.json();
          const address = data.display_name || data.address?.display_name || '';
          
          setProjectForm(prev => ({
            ...prev,
            latitude: lat.toFixed(6),
            longitude: lng.toFixed(6),
            address: address || `${lat}, ${lng}`
          }));
          setGoogleMapLink(''); // Clear input
          alert('✅ Đã lấy tọa độ và địa chỉ thành công!');
        } else {
          // Nếu không geocode được, vẫn lưu tọa độ
          setProjectForm(prev => ({
            ...prev,
            latitude: lat.toFixed(6),
            longitude: lng.toFixed(6)
          }));
          setGoogleMapLink('');
          alert('⚠️ Đã lấy tọa độ thành công, nhưng không thể lấy địa chỉ. Vui lòng nhập địa chỉ thủ công.');
        }
      } catch (error) {
        console.error('Error reverse geocoding:', error);
        // Nếu lỗi, vẫn lưu tọa độ
        setProjectForm(prev => ({
          ...prev,
          latitude: lat.toFixed(6),
          longitude: lng.toFixed(6)
        }));
        setGoogleMapLink('');
        alert('⚠️ Đã lấy tọa độ thành công! Vui lòng nhập địa chỉ thủ công.');
      }
    }
  };

  return (
    <div className="admin-page">
      <header className="admin-header">
        <h1>🔧 Quản Trị Hệ Thống</h1>
        <div className="admin-notice">
          <p>⚠️ <strong>Lưu ý:</strong> Trang web này chỉ dành cho quản trị viên. Nhân viên <strong>BẮT BUỘC</strong> phải sử dụng Mobile App để chấm công.</p>
        </div>
      </header>

      <nav className="admin-nav">
        <button
          className={activeTab === 'employees' ? 'active' : ''}
          onClick={() => setActiveTab('employees')}
        >
          👥 Nhân Viên
        </button>
        <button
          className={activeTab === 'projects' ? 'active' : ''}
          onClick={() => setActiveTab('projects')}
        >
          📍 Dự Án
        </button>
        <button
          className={activeTab === 'export' ? 'active' : ''}
          onClick={() => setActiveTab('export')}
        >
          📊 Xuất Báo Cáo
        </button>
        <button
          className={activeTab === 'clearData' ? 'active' : ''}
          onClick={() => setActiveTab('clearData')}
        >
          🗑️ Xóa Dữ Liệu
        </button>
      </nav>

      <main className="admin-main">
        {activeTab === 'employees' && (
          <div className="admin-section">
            <h2>Thêm Nhân Viên</h2>
            <form onSubmit={handleAddEmployee} className="admin-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Mã NV *</label>
                  <input
                    type="text"
                    value={employeeForm.code}
                    onChange={(e) => setEmployeeForm({ ...employeeForm, code: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Tên Nhân Viên *</label>
                  <input
                    type="text"
                    value={employeeForm.name}
                    onChange={(e) => setEmployeeForm({ ...employeeForm, name: e.target.value })}
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Chức Danh</label>
                  <input
                    type="text"
                    value={employeeForm.position}
                    onChange={(e) => setEmployeeForm({ ...employeeForm, position: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Phòng Ban</label>
                  <input
                    type="text"
                    value={employeeForm.department}
                    onChange={(e) => setEmployeeForm({ ...employeeForm, department: e.target.value })}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    value={employeeForm.email}
                    onChange={(e) => setEmployeeForm({ ...employeeForm, email: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Số Điện Thoại</label>
                  <input
                    type="text"
                    value={employeeForm.phone}
                    onChange={(e) => setEmployeeForm({ ...employeeForm, phone: e.target.value })}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Dự Án</label>
                  <input
                    type="text"
                    value={employeeForm.project}
                    onChange={(e) => setEmployeeForm({ ...employeeForm, project: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Trạng Thái</label>
                  <select
                    value={employeeForm.status}
                    onChange={(e) => setEmployeeForm({ ...employeeForm, status: e.target.value })}
                  >
                    <option value="Đang làm việc">Đang làm việc</option>
                    <option value="Đã nghỉ việc">Đã nghỉ việc</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Mật Khẩu (mặc định: 123456)</label>
                <input
                  type="text"
                  value={employeeForm.password}
                  onChange={(e) => setEmployeeForm({ ...employeeForm, password: e.target.value })}
                />
              </div>
              <button type="submit" disabled={loading} className="btn-primary">
                {loading ? 'Đang xử lý...' : 'Thêm Nhân Viên'}
              </button>
            </form>

            <div className="admin-list">
              <h3>Danh Sách Nhân Viên ({employees.length})</h3>
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Mã NV</th>
                    <th>Tên</th>
                    <th>Chức Danh</th>
                    <th>Phòng Ban</th>
                    <th>Trạng Thái</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.map((emp) => (
                    <tr key={emp.id}>
                      <td>{emp.code}</td>
                      <td>{emp.name}</td>
                      <td>{emp.position}</td>
                      <td>{emp.department}</td>
                      <td>{emp.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === 'projects' && (
          <div className="admin-section">
            <h2>Thêm Dự Án</h2>
            <form onSubmit={handleAddProject} className="admin-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Mã DA *</label>
                  <input
                    type="text"
                    value={projectForm.code}
                    onChange={(e) => setProjectForm({ ...projectForm, code: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Tên Dự Án *</label>
                  <input
                    type="text"
                    value={projectForm.name}
                    onChange={(e) => setProjectForm({ ...projectForm, name: e.target.value })}
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Link Google Maps</label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <input
                    type="text"
                    value={googleMapLink}
                    onChange={(e) => setGoogleMapLink(e.target.value)}
                    style={{ flex: 1 }}
                    placeholder="Dán link Google Maps (ví dụ: https://www.google.com/maps?q=10.762622,106.660172)"
                  />
                  <button
                    type="button"
                    onClick={handleParseGoogleMapLink}
                    style={{
                      padding: '0.75rem 1.5rem',
                      backgroundColor: '#4285f4',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontWeight: '500'
                    }}
                  >
                    🔍 Lấy tọa độ
                  </button>
                </div>
                <small style={{ color: '#666', marginTop: '4px', display: 'block' }}>
                  Hỗ trợ: ?q=lat,lng, @lat,lng, hoặc short link (maps.app.goo.gl/...)
                </small>
              </div>
              <div className="form-group">
                <label>Địa Chỉ</label>
                <input
                  type="text"
                  value={projectForm.address}
                  onChange={(e) => setProjectForm({ ...projectForm, address: e.target.value })}
                  placeholder="Địa chỉ sẽ được tự động điền khi lấy tọa độ từ link Google Maps"
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Vĩ Độ *</label>
                  <input
                    type="number"
                    step="any"
                    value={projectForm.latitude}
                    onChange={(e) => setProjectForm({ ...projectForm, latitude: e.target.value })}
                    required
                    readOnly
                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                  />
                </div>
                <div className="form-group">
                  <label>Kinh Độ *</label>
                  <input
                    type="number"
                    step="any"
                    value={projectForm.longitude}
                    onChange={(e) => setProjectForm({ ...projectForm, longitude: e.target.value })}
                    required
                    readOnly
                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Bán Kính (m) *</label>
                  <input
                    type="number"
                    step="any"
                    value={projectForm.radius}
                    onChange={(e) => setProjectForm({ ...projectForm, radius: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Trạng Thái</label>
                  <select
                    value={projectForm.status}
                    onChange={(e) => setProjectForm({ ...projectForm, status: e.target.value })}
                  >
                    <option value="hoạt động">hoạt động</option>
                    <option value="ngưng">ngưng</option>
                  </select>
                </div>
              </div>
              <button type="submit" disabled={loading} className="btn-primary">
                {loading ? 'Đang xử lý...' : 'Thêm Dự Án'}
              </button>
            </form>

            <div className="admin-list">
              <h3>Danh Sách Dự Án ({projects.length})</h3>
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Mã DA</th>
                    <th>Tên Dự Án</th>
                    <th>Địa Chỉ</th>
                    <th>Bán Kính</th>
                    <th>Trạng Thái</th>
                  </tr>
                </thead>
                <tbody>
                  {projects.map((proj, idx) => (
                    <tr key={idx}>
                      <td>{proj.code}</td>
                      <td>{proj.name}</td>
                      <td>{proj.address}</td>
                      <td>{proj.radius}m</td>
                      <td>{proj.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === 'export' && (
          <div className="admin-section">
            <h2>Xuất Báo Cáo Chấm Công</h2>
            <form onSubmit={handleExport} className="admin-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Ngày Bắt Đầu</label>
                  <input
                    type="date"
                    value={exportForm.startDate}
                    onChange={(e) => setExportForm({ ...exportForm, startDate: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Ngày Kết Thúc</label>
                  <input
                    type="date"
                    value={exportForm.endDate}
                    onChange={(e) => setExportForm({ ...exportForm, endDate: e.target.value })}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Nhân Viên (để trống = tất cả)</label>
                <select
                  value={exportForm.employeeId}
                  onChange={(e) => setExportForm({ ...exportForm, employeeId: e.target.value })}
                >
                  <option value="">Tất cả nhân viên</option>
                  {employees.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.code} - {emp.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Chọn Cột Xuất</label>
                <div className="column-checkboxes">
                  {availableColumns.map((col) => (
                    <label key={col} className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={exportForm.columns.includes(col)}
                        onChange={() => toggleColumn(col)}
                      />
                      {col}
                    </label>
                  ))}
                </div>
              </div>
              <button type="submit" disabled={loading || exportForm.columns.length === 0} className="btn-primary">
                {loading ? 'Đang xử lý...' : 'Xuất Excel'}
              </button>
            </form>
          </div>
        )}

        {activeTab === 'clearData' && (
          <div className="admin-section">
            <h2>🗑️ Xóa Dữ Liệu Chấm Công</h2>
            <div style={{ 
              backgroundColor: '#fff3cd', 
              border: '1px solid #ffc107', 
              borderRadius: '6px', 
              padding: '1rem', 
              marginBottom: '1.5rem' 
            }}>
              <p style={{ margin: 0, fontWeight: 'bold', color: '#856404' }}>
                ⚠️ CẢNH BÁO: Chức năng này sẽ xóa VĨNH VIỄN dữ liệu chấm công và ảnh trong khoảng thời gian đã chọn.
                Hành động này KHÔNG THỂ hoàn tác!
              </p>
            </div>
            <form onSubmit={handleClearData} className="admin-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Ngày Bắt Đầu *</label>
                  <input
                    type="date"
                    value={clearDataForm.startDate}
                    onChange={(e) => setClearDataForm({ ...clearDataForm, startDate: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Ngày Kết Thúc *</label>
                  <input
                    type="date"
                    value={clearDataForm.endDate}
                    onChange={(e) => setClearDataForm({ ...clearDataForm, endDate: e.target.value })}
                    required
                  />
                </div>
              </div>
              <button 
                type="submit" 
                disabled={loading || !clearDataForm.startDate || !clearDataForm.endDate} 
                className="btn-primary"
                style={{ 
                  backgroundColor: loading ? '#ccc' : '#dc3545',
                  borderColor: loading ? '#ccc' : '#dc3545'
                }}
              >
                {loading ? 'Đang xóa...' : '🗑️ Xóa Dữ Liệu'}
              </button>
            </form>
          </div>
        )}
      </main>

    </div>
  );
}

export default AdminPage;

